export const UPLOADED_IMAGE_FILE_ID_ATTRIBUTE = "data-file-id";

const htmlTagsRegex = /<[^>]*>/g;
const nonBreakingSpaceRegex = /&nbsp;/g;
const uploadedImageRegex = new RegExp(`<img\\b[^>]*\\s${UPLOADED_IMAGE_FILE_ID_ATTRIBUTE}=`, "i");

export const isHtmlContentEmpty = (htmlContent: string): boolean =>
  !uploadedImageRegex.test(htmlContent) &&
  htmlContent.replace(htmlTagsRegex, "").replace(nonBreakingSpaceRegex, " ").trim().length === 0;
